import { procedureMapComposites, ProcedureMapCompositePattern } from '@core/procedure-helpers/models/procedure-map-composites';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const ProcedureBridgeAvailabilityRules = [
	procedureMapComposites.fixedRestorativeAll
] as const satisfies ReadonlyArray<ProcedureMapCompositePattern>;
